export enum FooterType {
    Light = "light",
    Dark = "dark"
}